import * as React from "react";

const styles = require("./paddedListItem.scss");

interface IProps {
  leftElement: React.ReactNode;
  rightElement: React.ReactNode;
  className?: string;
}

const PaddedListItem = ({ leftElement, rightElement, className }: IProps) => {
  return (
    <li className={`${styles.itemWrapper} ${className}`}>
      <div className={styles.left}>{leftElement}</div>
      <div className={styles.right}>{rightElement}</div>
    </li>
  );
};

export default PaddedListItem;
